import LocalStorage from 'utils/bom-dom-manipulation/local-storage';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { storageKeyName } from 'utils/generic/storage-key-name';
import { EMatchStreamingTypes } from 'interfaces/match-streaming';

export const shouldShowLiveTime = (isLive: boolean, sport = ''): boolean => {
  if (isLive) {
    return sport.toLowerCase() !== 'golf';
  } else {
    return false;
  }
};

export const streamTabOnclick = (tabMode: EMatchStreamingTypes): void => {
  LocalStorage.setItem(
    storageKeyName('sportsbook', 'STREAM_ACTIVE_TAB_MODE'),
    `${tabMode}`
  );
};

export const isActiveStreamTabMode = (): boolean => {
  const STREAM_ACTIVE_TAB_MODE: EMatchStreamingTypes | number = parseInt(
    LocalStorage.getItem(storageKeyName('sportsbook', 'STREAM_ACTIVE_TAB_MODE'))
  );

  const allTypes = Object.keys(EMatchStreamingTypes)
    .filter(item => +item === +item)
    .map(item => +item);

  const ACTIVE_STREAM_TAB: EMatchStreamingTypes = allTypes.includes(
    STREAM_ACTIVE_TAB_MODE
  )
    ? STREAM_ACTIVE_TAB_MODE
    : +SpringConfigs.IS_ACTIVE_STREAM_TAB;

  return allTypes.filter(mode => +mode).includes(ACTIVE_STREAM_TAB);
};
